import { motion } from "framer-motion";
import { SUPPORT_EMAIL, WHATSAPP_DISPLAY, WHATSAPP_NUMBER } from "@/lib/config";
import { useLang } from "@/lib/LanguageContext";

export default function Footer() {
    const { t } = useLang();
    const year = new Date().getFullYear();
    return (
        <footer
            className="bg-[#2D2824] text-[#F9F6F0] pt-24 md:pt-32"
            data-testid="site-footer"
        >
            <div className="container-x">
                <motion.h2
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 1, ease: [0.19, 1, 0.22, 1] }}
                    className="font-serif text-[22vw] md:text-[16vw] leading-[0.9] tracking-[-0.04em] text-[#F9F6F0] select-none"
                    data-testid="footer-brand-mark"
                >
                    VARDHAN
                    <sup className="text-[0.15em] align-super text-[#B48F57] ml-2">
                        ™
                    </sup>
                </motion.h2>

                <div className="grid grid-cols-12 gap-8 mt-16 pb-16 border-t border-[#5C564D] pt-14">
                    <div className="col-span-12 md:col-span-5">
                        <div className="eyebrow text-[#B48F57] mb-4">
                            {t("footer.disclaimer_label")}
                        </div>
                        <p
                            className="text-[13px] md:text-[14px] text-[#D9D1C7] leading-relaxed max-w-[52ch] font-light"
                            data-testid="footer-disclaimer"
                        >
                            {t("footer.disclaimer")}
                        </p>
                    </div>
                    <div className="col-span-6 md:col-span-3">
                        <div className="eyebrow text-[#B48F57] mb-4">
                            {t("footer.support")}
                        </div>
                        <ul className="space-y-3 text-[14px] text-[#D9D1C7] font-light">
                            <li>
                                <a
                                    href={`https://wa.me/${WHATSAPP_NUMBER}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="hover:text-[#B48F57] transition-colors"
                                    data-testid="footer-link-whatsapp"
                                >
                                    {t("footer.wa")} · {WHATSAPP_DISPLAY}
                                </a>
                            </li>
                            <li>
                                <a
                                    href={`mailto:${SUPPORT_EMAIL}`}
                                    className="hover:text-[#B48F57] transition-colors break-all"
                                    data-testid="footer-link-email"
                                >
                                    {SUPPORT_EMAIL}
                                </a>
                            </li>
                            <li>
                                <button
                                    onClick={() =>
                                        document
                                            .getElementById("faq")
                                            ?.scrollIntoView({ behavior: "smooth" })
                                    }
                                    className="hover:text-[#B48F57] transition-colors"
                                    data-testid="footer-link-faq"
                                >
                                    {t("footer.faq")}
                                </button>
                            </li>
                        </ul>
                    </div>
                    <div className="col-span-6 md:col-span-4">
                        <div className="eyebrow text-[#B48F57] mb-4">
                            {t("footer.product")}
                        </div>
                        <ul className="space-y-3 text-[14px] text-[#D9D1C7] font-light">
                            <li>{t("footer.p1")}</li>
                            <li>{t("footer.p2")}</li>
                            <li>{t("footer.p3")}</li>
                        </ul>
                    </div>
                </div>

                <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 border-t border-[#5C564D] py-8 text-[12px] tracking-[0.14em] uppercase text-[#8A837A]">
                    <span data-testid="footer-copyright">
                        {t("footer.copyright", { year })}
                    </span>
                    <span>{t("footer.shake")}</span>
                </div>
            </div>
        </footer>
    );
}
